import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { useScreenLockStore } from '@/stores/screenLock'

export const useDrawerNavigationStore = defineStore('drawerNavigation', () => {
  const screenLock = useScreenLockStore()

  interface DrawerNavigationContext {
    isShow: boolean,
  }
  const context: DrawerNavigationContext = reactive({
    isShow: false,
  })

  const showDrawerNavigation = ():void => {
    context.isShow = true
    screenLock.lockScreen({
      hasBlackOut: true,
      hasBlur: true,
      hasWaitAnimation: false,
      hasScrollLock: false, // スクロールロックすると、iOS でドロワーナビ内のスクロールができなくなるため、スクロールのロックはしない
    })
  }

  const hideDrawerNavigation = ():void => {
    context.isShow = false
    screenLock.unlockScreen()
  }

  return {
    // data
    context,

    // methods
    showDrawerNavigation,
    hideDrawerNavigation,
  }
})
